var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashregistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16093",
    "data-name": "Group 16093",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7259",
    "data-name": "Path 7259",
    d: "M21.623.779A2.623,2.623,0,0,0,19.757,0H2.623A2.623,2.623,0,0,0,0,2.623V37.377A2.623,2.623,0,0,0,2.623,40H29.377A2.623,2.623,0,0,0,32,37.377V32.51l-3.148,2.977V35.8A1.049,1.049,0,0,1,27.8,36.852H4.2A1.049,1.049,0,0,1,3.148,35.8V4.2A1.049,1.049,0,0,1,4.2,3.148H18.623v6.3a4.2,4.2,0,0,0,4.2,4.2h6.033v7.6L32,18.256v-5.9a2.622,2.622,0,0,0-.758-1.844Zm16.171,15.33-1.727,1.727,3.541,3.672,1.75-1.859a.525.525,0,0,0-.011-.73l-2.81-2.81A.524.524,0,0,0,37.793,16.109Zm-3.17,2.908L25.836,27.8l3.8,3.8,8.787-8.656Zm-10.1,10.1,3.8,3.8-2.485,1.42a1.572,1.572,0,0,1-.577.194l-2.053.268a.524.524,0,0,1-.59-.572l.165-1.65a1.573,1.573,0,0,1,.182-.593ZM8.656,16.787a1.574,1.574,0,0,0,0,3.148H9.18a1.574,1.574,0,1,0,0-3.148Zm5.508,0a1.574,1.574,0,0,0,0,3.148h8.918a1.574,1.574,0,0,0,0-3.148ZM7.082,25.18a1.574,1.574,0,0,1,1.574-1.574H9.18a1.574,1.574,0,0,1,0,3.148H8.656A1.574,1.574,0,0,1,7.082,25.18Zm1.574,5.246a1.574,1.574,0,0,0,0,3.148H9.18a1.574,1.574,0,0,0,0-3.148ZM12.59,25.18a1.574,1.574,0,0,1,1.574-1.574h8.918a1.574,1.574,0,0,1,0,3.148H14.164A1.574,1.574,0,0,1,12.59,25.18Zm1.574,5.246h6.713a11.007,11.007,0,0,0-.6,3.148H14.164a1.574,1.574,0,0,1,0-3.148Z",
    transform: "translate(179 280)",
    fill: "#0f5a9c",
    fillRule: "evenodd",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashregistration);
export default __webpack_public_path__ + "static/media/dashregistration.102264d1e5c42f4a7f20dab07efd4af1.svg";
export { ForwardRef as ReactComponent };